import React, { useState, useEffect } from 'react';
import './DBSettings.css';

const DBSettings = () => {
  // API 베이스 URL 설정 (App.js와 동일한 로직)
  const API_BASE_URL = process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? `http://${window.location.hostname}:3002` : '');

  const [currentStatus, setCurrentStatus] = useState(null);
  const [testResults, setTestResults] = useState({ idc: null, office: null });
  const [testing, setTesting] = useState({ idc: false, office: false });
  const [switching, setSwitching] = useState(false);

  // DB 설정
  const dbConfigs = {
    idc: {
      name: 'IDC DB (메인)',
      server: 'd136.tlogin.net',
      port: 52785,
      database: 'LCS_BUCAR',
      user: 'logins',
      password: 'ghkfkdahrfh40-8'
    },
    office: {
      name: '사무실 DB (백업)',
      server: '211.198.4.245',
      port: 52785,
      database: 'LCS_BUCAR',
      user: 'logins',
      password: 'ghkfkdahrfh40-8'
    }
  };

  // 현재 DB 상태 조회
  const fetchCurrentStatus = async () => {
    try {
      console.log('🔍 [DB 상태 조회 시작]', API_BASE_URL);
      const response = await fetch(`${API_BASE_URL}/api/db/status`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        cache: 'no-cache'
      });

      console.log('📥 [응답 상태]', response.status, response.statusText);

      // 응답이 JSON인지 확인
      const contentType = response.headers.get('content-type');
      console.log('📋 [Content-Type]', contentType);

      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('❌ [API 응답이 JSON이 아님]', text.substring(0, 200));
        setCurrentStatus({
          success: false,
          connected: false,
          error: `API 응답 형식 오류 (HTML 반환됨): ${text.substring(0, 50)}...`,
          hint: '로그인이 성공했다면 실제로는 DB에 연결되어 있을 수 있습니다. 백엔드 포트(3002) 연결을 확인하세요.'
        });
        return;
      }

      const data = await response.json();
      console.log('✅ [DB 상태 데이터]', data);
      setCurrentStatus(data);
    } catch (error) {
      console.error('❌ [DB 상태 조회 실패]', error);
      setCurrentStatus({
        success: false,
        connected: false,
        error: error.message,
        hint: '로그인이 성공했다면 실제로는 DB에 연결되어 있을 수 있습니다.'
      });
    }
  };

  // DB 연결 테스트
  const testConnection = async (target) => {
    setTesting({ ...testing, [target]: true });

    try {
      const config = dbConfigs[target];
      console.log('🔍 [DB 연결 테스트 시작]', target, API_BASE_URL);
      const response = await fetch(`${API_BASE_URL}/api/db/test`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(config)
      });

      // 응답이 JSON인지 확인
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('API 응답이 JSON이 아닙니다:', text.substring(0, 200));
        setTestResults({
          ...testResults,
          [target]: {
            success: false,
            message: 'API 응답 형식 오류 (HTML 페이지가 반환됨). 백엔드 서버를 확인하세요.'
          }
        });
        setTesting({ ...testing, [target]: false });
        return;
      }

      const data = await response.json();
      setTestResults({ ...testResults, [target]: data });
    } catch (error) {
      console.error('DB 연결 테스트 실패:', error);
      setTestResults({
        ...testResults,
        [target]: { success: false, message: error.message }
      });
    } finally {
      setTesting({ ...testing, [target]: false });
    }
  };

  // DB 전환
  const switchDatabase = async (target) => {
    if (!window.confirm(`${dbConfigs[target].name}(으)로 전환하시겠습니까?`)) {
      return;
    }

    setSwitching(true);

    try {
      console.log('🔄 [DB 전환 시작]', target, API_BASE_URL);
      const response = await fetch(`${API_BASE_URL}/api/db/switch`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ target })
      });

      const data = await response.json();

      if (data.success) {
        alert(data.message);
        await fetchCurrentStatus();
      } else {
        alert(`전환 실패: ${data.message}`);
      }
    } catch (error) {
      alert(`전환 실패: ${error.message}`);
    } finally {
      setSwitching(false);
    }
  };

  useEffect(() => {
    fetchCurrentStatus();
  }, []);

  return (
    <div className="db-settings-container">
      <div className="db-settings-header">
        <h2>🔧 데이터베이스 연결 설정</h2>
        <button onClick={fetchCurrentStatus} className="btn-refresh">
          🔄 새로고침
        </button>
      </div>

      {/* 현재 연결 상태 */}
      <div className="current-status">
        <h3>📊 현재 연결 상태</h3>
        {currentStatus ? (
          <div className={`status-box ${currentStatus.connected ? 'connected' : 'disconnected'}`}>
            <div className="status-indicator">
              {currentStatus.connected ? '✅ 연결됨' : '❌ 연결 끊김'}
            </div>
            {currentStatus.connected ? (
              <>
                <div className="status-info">
                  <strong>서버 주소:</strong> <span className="server-address">
                    {currentStatus.configServer || currentStatus.server || '확인 중...'}
                    {currentStatus.configPort && `:${currentStatus.configPort}`}
                  </span>
                </div>
                {currentStatus.configServer && (
                  <div className="status-info">
                    <strong>IP 주소:</strong> <span className="server-address">
                      {currentStatus.configServer === 'd136.tlogin.net' ? '121.156.116.136' :
                        currentStatus.configServer === '211.198.4.245' ? '211.198.4.245' :
                          currentStatus.configServer}
                      {currentStatus.configPort && `:${currentStatus.configPort}`}
                    </span>
                  </div>
                )}
                <div className="status-info">
                  <strong>데이터베이스:</strong> {currentStatus.database || 'LCS_BUCAR'}
                </div>
                {currentStatus.server && (
                  <div className="status-info-detailed">
                    {currentStatus.server.includes('d136.tlogin.net') || currentStatus.configServer === 'd136.tlogin.net' ? (
                      <span className="db-badge idc">🖥️ IDC DB (메인) - 현재 연결됨</span>
                    ) : currentStatus.server.includes('211.198.4.245') || currentStatus.configServer === '211.198.4.245' ? (
                      <span className="db-badge office">🏢 사무실 DB (백업) - 현재 연결됨</span>
                    ) : (
                      <span className="db-badge unknown">❓ 알 수 없음 - {currentStatus.server}</span>
                    )}
                  </div>
                )}
              </>
            ) : (
              <div className="status-error">
                {currentStatus.error ? (
                  <div className="error-message">⚠️ {currentStatus.error}</div>
                ) : (
                  <div className="error-message">⚠️ DB 연결 정보를 가져올 수 없습니다.</div>
                )}
                {currentStatus.hint && (
                  <div className="error-hint">
                    {currentStatus.hint}
                  </div>
                )}
                <div className="error-hint">
                  💡 <strong>로그인에 성공했다면</strong> 실제로는 DB에 연결되어 있을 수 있습니다.<br />
                  브라우저 개발자 도구(F12) → Console 탭에서 에러를 확인하거나 페이지를 새로고침(Ctrl+F5)해보세요.
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="loading">로딩 중...</div>
        )}
      </div>

      {/* DB 연결 테스트 */}
      <div className="db-test-section">
        <h3>🔍 연결 테스트</h3>

        {Object.entries(dbConfigs).map(([key, config]) => (
          <div key={key} className="db-card">
            <div className="db-card-header">
              <h4>{config.name}</h4>
              <span className="db-server">{config.server}:{config.port}</span>
            </div>

            <div className="db-card-body">
              <div className="db-info">
                <div><strong>데이터베이스:</strong> {config.database}</div>
                <div><strong>사용자:</strong> {config.user}</div>
              </div>

              {testResults[key] && (
                <div className={`test-result ${testResults[key].success ? 'success' : 'error'}`}>
                  <div className="result-header">
                    {testResults[key].success ? '✅ 연결 성공' : '❌ 연결 실패'}
                  </div>
                  {testResults[key].success ? (
                    <>
                      <div className="result-detail">
                        <strong>응답 시간:</strong> {testResults[key].connectTime}ms
                      </div>
                      <div className="result-detail">
                        <strong>SQL Server:</strong> {testResults[key].version}
                      </div>
                      <div className="result-detail">
                        <strong>Decrypt 함수:</strong> {testResults[key].decryptAvailable ? (
                          <span className="decrypt-available">✅ 사용 가능 (로그인 가능)</span>
                        ) : (
                          <span className="decrypt-unavailable">
                            ❌ 사용 불가 (로그인 불가능)
                            <span className="decrypt-hint"> - 암호화 키가 복제되지 않았을 수 있습니다</span>
                          </span>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="result-detail error-message">
                      {testResults[key].message}
                    </div>
                  )}
                </div>
              )}

              <div className="db-card-actions">
                <button
                  onClick={() => testConnection(key)}
                  disabled={testing[key]}
                  className="btn-test"
                >
                  {testing[key] ? '테스트 중...' : '🔍 연결 테스트'}
                </button>

                <button
                  onClick={() => switchDatabase(key)}
                  disabled={switching || !testResults[key]?.success}
                  className="btn-switch"
                >
                  {switching ? '전환 중...' : '🔄 이 DB로 전환'}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 도움말 */}
      <div className="help-section">
        <h3>💡 사용 방법</h3>
        <ol>
          <li><strong>연결 테스트</strong>: 각 DB의 "연결 테스트" 버튼을 클릭하여 연결 상태를 확인합니다.</li>
          <li><strong>Decrypt 함수 확인</strong>: 로그인에 필요한 Decrypt 함수가 정상 작동하는지 확인합니다.</li>
          <li><strong>DB 전환</strong>: 테스트가 성공한 DB로 전환할 수 있습니다.</li>
          <li><strong>권장 사항</strong>: IDC DB가 메인이므로, 가능하면 IDC DB를 사용하세요.</li>
        </ol>
      </div>
    </div>
  );
};

export default DBSettings;

